module.exports = __webpack_public_path__ + "img/header-engagementRings.ceb316f.jpg";